import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ServiceModalPage } from "./../../pages/service-modal/service-modal.page";
import { Service } from "./../../interfaces/service";
import { Category } from "src/app/interfaces/category";
import { EnvironmentService } from "src/app/services/environment/environment.service";
import { Salon } from "src/app/interfaces/salon";
import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-services-list",
  templateUrl: "./services-list.component.html",
  styleUrls: ["./services-list.component.scss"],
})
export class ServicesListComponent implements OnInit {
  @Input() categoryName: string;
  @Input() salon: Salon;
  @Input() services: [];
  @Input() category: Category;

  on_bonnie: boolean;

  private modal: HTMLIonModalElement = null;

  constructor(
    private env: EnvironmentService,
    private modalController: ModalController,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    // console.log({services: this.services});
    this.on_bonnie = this.env.api.salon_id === null;
  }

  setActiveSalon(salon: Salon, event: MouseEvent) {
    const currentSalon = JSON.parse(localStorage.getItem("current-salon"));

    if (currentSalon === null) {
      localStorage.setItem("current-salon", JSON.stringify(salon));
    }

    localStorage.setItem("next-salon", JSON.stringify(salon));
  }

  async openModal(service: Service, bookNowBtn: HTMLAnchorElement) {
    const modalRef = this.modalService.open(ServiceModalPage);
    modalRef.componentInstance.service = service;

    // will resolve when the user closes the modal
    const result = await modalRef.result;

    if (result === "book-now") {
      bookNowBtn.click();
    }
  }
}
